module.exports = __webpack_public_path__ + "static/media/31JFA8.ed558618.jpg";